import React, { useEffect, useState } from "react";
import {
	IconButton,
	Tooltip,
	Typography,
	Link,
	Button,
	Grid,
	LinearProgress,
	Box,
} from "@mui/material";
import { useSelector } from "react-redux";

import { CommentIcon } from "utility/icons";
import "components/Layout/Sidebar/WorkFlowApprovalStepsHistory/WorkFlowApprovalStepsHistory.css";
import { Shared } from "utility/shared";
import Emitter from "utility/emitter";
import ResponsiveDialog from "components/ResponsiveDialog";
import { RootState } from "redux/store";
import { IStepHistoryComment } from "models/StepHistoryDetail";
import { CustomTooltip } from "components/CustomTooltip";
import {
	IS_BID_ASSIGNED_TO_USER,
	OPEN_BID_STEP_HISTORY_DETAIL,
} from "utility/emitterEvents";
import { ActionType } from "utility/enums/action-type";
import {
	BidStepHistoryEmitter,
	IBidStepHistory,
} from "models/Bid/BidSummaryGridDetail";
import { BidStepHistoryStatus } from "utility/enums/bid-detail";
import { BidService } from "services/bid.service";
import { AppRoutings } from "utility/enums/app-routings";
import { useNavigate } from "react-router-dom";
import { Loading } from "components/Loading";
import { BidWorkflowPhase } from "utility/enums/bid-workflow-phase";

type Props = {
	bidDetail: BidStepHistoryEmitter;
};

export const RequisitionConversionToBidStepHistory: React.FC<Props> = ({
	bidDetail,
}) => {
	const navigate = useNavigate();
	const userDetails = useSelector(
		(state: RootState) => state.authState.userDetails
	);
	const [stepHistoryList, setStepHistoryList] = useState<IBidStepHistory[]>([]);
	const [openInfoDialog, setOpenInfoDialog] = useState<{
		open: boolean;
		message: string;
	}>({ open: false, message: "" });
	const [activeStepIndex, setActiveStepIndex] = useState<number>(-1);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const isStepAssignedToUser = (step: IBidStepHistory) => {
		if (step.modulePhaseId === BidWorkflowPhase.SupplierBidding) {
			return true;
		} else {
			return step.assignToUsers && step.assignToUsers.length > 0
				? step.assignToUsers.findIndex((r) => r.userId === userDetails.userId) >
						-1
				: false;
		}
	};

	const openBidStepHistoryDetail = (
		item: IBidStepHistory,
		actionType?: ActionType
	) => {
		// Emitter.off(OPEN_BID_STEP_HISTORY_DETAIL, {} as any);
		// const tempActionType =
		// 	actionType ||
		// 	(isStepAssignedToUser(item) &&
		// 	item.bidStepStatusName === BidStepHistoryStatus.Ready
		// 		? ActionType.Edit
		// 		: ActionType.View);
		// Emitter.emit(OPEN_BID_STEP_HISTORY_DETAIL, {
		// 	stepHistoryDetail: item,
		// 	actionType: tempActionType,
		// 	isStepAssignedToUser: isStepAssignedToUser(item),
		// });
		Emitter.off(OPEN_BID_STEP_HISTORY_DETAIL, {} as any);
		Emitter.emit(OPEN_BID_STEP_HISTORY_DETAIL, item);
	};

	// const setPrevStepAsSelected = (
	// 	stepHistoryList: IBidStepHistory[],
	// 	filteredList: IBidStepHistory[]
	// ) => {
	// 	for (let i = 0; i < filteredList.length; i++) {
	// 		const element = filteredList[i];
	// 		if (
	// 			isStepAssignedToUser(element) &&
	// 			element.bidStepStatusName !== BidStepHistoryStatus.Pending
	// 		) {
	// 			const index = stepHistoryList.findIndex(
	// 				(r) =>
	// 					r.bidStepId === element.bidStepId &&
	// 					r.sequenceNumber === element.sequenceNumber
	// 			);
	// 			if (index > -1) {
	// 				setActiveStepIndex(index);
	// 				openBidStepHistoryDetail(stepHistoryList[index]);
	// 				break;
	// 			}
	// 		}
	// 		// if no prev step is assigned to user, set first step as selected
	// 		if (filteredList.length - 1 === i) {
	// 			setActiveStepIndex(0);
	// 			openBidStepHistoryDetail(stepHistoryList[0], ActionType.View);
	// 		}
	// 	}
	// };

	const setPrevStepAsSelected = (
		stepHistoryList: IBidStepHistory[],
		filteredList: IBidStepHistory[]
	) => {
		for (let i = 0; i < filteredList.length; i++) {
			const element = filteredList[i];
			if (isStepAssignedToUser(element)) {
				const index = stepHistoryList.findIndex(
					(r) => r.bidStepId === element.bidStepId
				);
				if (index > -1) {
					setActiveStepIndex(index);
					openBidStepHistoryDetail(stepHistoryList[index]);
					Emitter.emit(
						IS_BID_ASSIGNED_TO_USER,
						isStepAssignedToUser(stepHistoryList[index])
					);
					break;
				}
			}
			// if no prev step is assigned to user, set first step as selected
			if (filteredList.length - 1 === i) {
				setActiveStepIndex(0);
				openBidStepHistoryDetail(stepHistoryList[0]);
				// openBidStepHistoryDetail(stepHistoryList[0], ActionType.View);
			}
		}
	};

	useEffect(() => {
		// get bidStepHistoryList
		if (bidDetail.bidId > -1) {
			setIsLoading(true);
			setActiveStepIndex(-1);
			BidService.getBidStepList(bidDetail.bidId)
				.then((result) => {
					setStepHistoryList(result);
					const index = result.findIndex(
						(r) => r.bidStepId === bidDetail.bidStepId
					);
					if (index > -1) {
						if (isStepAssignedToUser(result[index])) {
							setActiveStepIndex(index);
							// openBidStepHistoryDetail(
							// 	result[index],
							// 	result[index].bidStepStatusName === BidStepHistoryStatus.Ready
							// 		? ActionType.Edit
							// 		: ActionType.View
							// );

							Emitter.emit(
								IS_BID_ASSIGNED_TO_USER,
								isStepAssignedToUser(result[index])
							);
						} else {
							setPrevStepAsSelected(
								result,
								JSON.parse(JSON.stringify(result)).slice(0, index).reverse()
							);
						}
					} else {
						setPrevStepAsSelected(
							result,
							JSON.parse(JSON.stringify(result)).reverse()
						);
					}
					setIsLoading(false);
				})
				.catch((err) => {
					Shared.showSnackbarMessage(
						"Error loading bid step history list, please try again"
					);
					navigate(AppRoutings.BidSummaryGrid);
					setIsLoading(false);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [bidDetail.bidId, bidDetail.bidStepId]);

	const getClassName = (status: string) => {
		let classes: string = "steps-root ";
		if (status === BidStepHistoryStatus.Ready) {
			classes += "in-progress";
		}
		if (status === BidStepHistoryStatus.Completed) {
			classes += "complete";
		}
		if (status === BidStepHistoryStatus.Recalled) {
			classes += "recall";
		}
		if (status === BidStepHistoryStatus.ChangeRequested) {
			classes += "change-request";
		}
		if (status === BidStepHistoryStatus.Rejected) {
			classes += "reject";
		}
		if (status === BidStepHistoryStatus.Deleted) {
			classes += "delete";
		}
		if (status === BidStepHistoryStatus.Delegated) {
			classes += "delegate";
		}
		if (status === BidStepHistoryStatus.Escalated) {
			classes += "escalate";
		}
		if (status === BidStepHistoryStatus.Cancelled) {
			classes += "cancel";
		}
		return classes;
	};

	const handleStepDetailClick = (item: IBidStepHistory, index: number) => {
		if (activeStepIndex === index || bidDetail.isSupplierBidding) {
			return;
		}
		if (
			item.bidStepStatusName === BidStepHistoryStatus.Pending ||
			(!isStepAssignedToUser(item) &&
				item.bidStepStatusName === BidStepHistoryStatus.Ready)
		) {
			if (!(item.modulePhaseId === BidWorkflowPhase.SupplierBidding)) {
				setOpenInfoDialog({
					open: true,
					message: !isStepAssignedToUser(item)
						? `You do not have permission to access the step ${item.stepNumber}.`
						: `The step selected ${item.stepNumber}, has not been completed and there is no information to display for the step.`,
				});
			}
		} else {
			setActiveStepIndex(index);
			openBidStepHistoryDetail(item);
			Emitter.emit(IS_BID_ASSIGNED_TO_USER, isStepAssignedToUser(item));
		}
	};

	return (
		<div className="history-panel">
			<div className="heading-part">
				<Typography variant="h4">Bid Process</Typography>
				{stepHistoryList.length > 0 && (
					<div className="stepper-wrapper">
						<Typography variant="caption">
							{`${stepHistoryList[0].stepCompletedInPercentage}% Completed`}
						</Typography>
						<Box sx={{ ml: 1, maxWidth: 400, flexGrow: 1 }}>
							<LinearProgress
								variant="determinate"
								value={stepHistoryList[0].stepCompletedInPercentage}
							/>
						</Box>
					</div>
				)}
			</div>
			<div className="steps-wrapper">
				{!stepHistoryList.length &&
					(isLoading ? (
						<Loading isWorkflowStepLoader={true} />
					) : (
						<Typography
							className="steps-root"
							variant="body1"
							justifyContent="center"
						>
							No Data Available
						</Typography>
					))}
				{stepHistoryList.length > 0 &&
					stepHistoryList.map((item: IBidStepHistory, index: number) => (
						<Link
							key={index}
							onClick={(e) => {
								e.preventDefault();
								handleStepDetailClick(item, index);
							}}
							underline="none"
							className={`${getClassName(item.bidStepStatusName)} ${
								index === activeStepIndex && "active"
							}`}
							style={{
								cursor: "pointer",
							}}
							id={index === activeStepIndex ? "active" : undefined}
						>
							<Tooltip title={item.bidStepStatusName} placement="bottom">
								<div className="steps-icon">{item.stepNumber}</div>
							</Tooltip>
							<div className="step-content">
								<Typography variant="body2">{item.description}</Typography>
								<Typography variant="caption">
									{(item.bidStepStatusName === BidStepHistoryStatus.Completed &&
									item.stepNumber === "1.0"
										? item.assignToUsers.filter((user) => user.isTaskCompleted)
										: item.assignToUsers
									).map((user, index, arr) => (
										<span
											key={index}
											className={
												user.isTaskCompleted ? "green-text fw-500" : ""
											}
										>{`${user.fullName}${
											index !== arr.length - 1 ? ", " : ""
										}`}</span>
									))}
								</Typography>
								<div className="step-content-middle">
									<div className="left-part">
										<Typography variant="caption" className="light">
											Duration
										</Typography>
										<Typography variant="caption">
											{item.duration || "-"}
										</Typography>
									</div>
									<div className="right-part">
										<Typography variant="caption" className="light">
											Avg. Duration
										</Typography>
										<Typography variant="caption">
											{item.averageDuration || "-"}
										</Typography>
									</div>
								</div>
								<div className="step-content-bottom">
									<Tooltip
										title={
											item.completedDate
												? `Completed by ${item.completedBy}`
												: ""
										}
										arrow
										placement="top"
									>
										<div className="left-part">
											<Typography variant="caption" className="light">
												Date Completed
											</Typography>
											<Typography variant="caption">
												{item.completedDate
													? `${Shared.getFormattedDate(
															new Date(item.completedDate),
															"dd/MM/yyyy"
													  )} - ${Shared.getFormattedDate(
															new Date(item.completedDate),
															"hh:mmaaa"
													  )}`
													: "-"}
											</Typography>
										</div>
									</Tooltip>
									{item.comments.length > 0 && (
										<CustomTooltip
											tooltipStyle={{
												border: "1px solid #034f8b",
											}}
											tooltipProps={{
												title: item.comments.map(
													(cmt: IStepHistoryComment, index: number) => (
														<Grid
															container
															key={index}
															className={index !== 0 ? "history-comment" : ""}
														>
															<Grid item xs={12} className="fw-500">
																{cmt.fullName}
															</Grid>
															<Grid item xs={12} mt={1}>
																{cmt.comment}
															</Grid>
														</Grid>
													)
												),
												className: "history-tooltip",
												placement: "right",
												children: (
													<IconButton>
														<CommentIcon />
													</IconButton>
												),
											}}
										/>
									)}
								</div>
							</div>
						</Link>
					))}
			</div>
			{openInfoDialog.open && (
				<ResponsiveDialog
					open={openInfoDialog.open}
					title="Step History Info"
					showActionButtons={false}
					titleCloseIcon={false}
					maxWidth="xs"
					onCancel={() => {}}
				>
					<Grid container spacing={1}>
						<Grid item xs={12}>
							<Typography variant="h4" color="black">
								{openInfoDialog.message}
							</Typography>
						</Grid>
						<Grid
							item
							xs={12}
							textAlign="center"
							sx={{ paddingTop: "24px !important" }}
						>
							<Button
								variant="contained"
								onClick={() => {
									setOpenInfoDialog({ open: false, message: "" });
								}}
							>
								Close
							</Button>
						</Grid>
					</Grid>
				</ResponsiveDialog>
			)}
		</div>
	);
};
